import React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { logoutService, SilentLogoutService ,  getCurrentUser } from './../api/userapi';
import { StripeUrl } from "./../api/clubapi";
import { connect } from 'react-redux';
import { SystemInfoView } from './systemInfo/systemInfoView';

class NavMenu extends React.Component {
  constructor(props) {
    super(props);
    this.userInfo = getCurrentUser();
    this.toggle = this.toggle.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.state = {
      isOpen: false
    };
  }

  onLogout() {
    this.props.logOut();
  }

  toggle() {
    debugger;
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  Striperedirect() {
    this.props.StripeUrl(function (result, _this) { _this.getData(result, _this) }, this, this.userInfo.data.clubId)
  }

  getData(data, _this) {
    window.location.href = data.data;
    this.props.silentlogOut();
  }

  render() {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow" light >
          <Container>
            <NavbarBrand tag={Link} to="/secure/gifts"><img src="./aaa_logo.png" alt="logo" className="title-logo" /></NavbarBrand>
            <SystemInfoView showTitle = "true"></SystemInfoView>
            <NavbarToggler onClick={this.toggle} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
              <ul className="navbar-nav flex-grow">
                {/* <NavItem className="px-2">
                            <NavLink tag={Link} to="/secure/" className="menu-buttons">Reset Password</NavLink>
                        </NavItem> */}
                <NavItem>
                  <NavLink tag={Link} to="#" className="menu-buttons">{this.userInfo.data.email}</NavLink>
                </NavItem>
                {this.userInfo.data.stripeChargeId ? null :
                <NavItem>
                  <div className="vertical-row ml-2"></div>
                  <NavLink tag={Link} to="#" onClick={this.Striperedirect.bind(this)} className="menu-buttons">Connect My Stripe Account</NavLink>
                </NavItem> }
                <div className="vertical-row ml-2"></div>
                <NavItem>
                  <NavLink tag={Link} to="#" onClick={this.onLogout} className="menu-buttons">Log Out</NavLink>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}

export default connect(
  state => {
    return {
      userResponse: state.data.userResponse
    }
  },
  dispatch => ({
    logOut: () => { dispatch(logoutService()); },
    silentlogOut: () => { dispatch(SilentLogoutService()); },
    StripeUrl: ( callback, context, clubId) => { dispatch(StripeUrl( callback, context,clubId)) }
  })
)(NavMenu);